import React, { ReactElement } from 'react';
import ReactApexChart from 'react-apexcharts';

interface Props<TypePairedColumnChart> {
    firstSeriec: TypeSeries;
    secondSeries: TypeSeries;
    categories: string[];
    color?: string[];
    title?: string;
};
interface TypeSeries {
    name: string;
    data: number[];
};

export default function PairedColumnChart<TypePairedColumnChart>({ firstSeriec, secondSeries, categories, color, title }: Props<TypePairedColumnChart>): ReactElement {

    const data = {

        series: [firstSeriec, secondSeries] || [],
        options: {
            chart: {
                // type: 'bar',
                // height: 350
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded',
                    borderRadius: 10,
                    // distributed: true,
                    dataLabels: {
                        position: 'top', // top, center, bottom
                    },
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: categories || [],
            },
            // yaxis: {
            //     title: {
            //         text: '$ (thousands)'
            //     }
            // },
            fill: {
                opacity: 1
            },
            title: {
                text: title || '',
                // align: 'left'
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + "%"
                    }
                }
            },
            colors: color || ['#008000', '#055DC9'],
        },

    };

    return (
        <div>
            <ReactApexChart options={data.options} series={data.series} type="bar" height={350} />
        </div>
    )
};
